export const EventEmitter = {
  events: {},
  execute: function (event: string, data: any) {
    //@ts-ignore
    if (!this.events[event]) return;
    //@ts-ignore
    this.events[event].forEach((callback: (data: any) => void) =>
      callback(data),
    );
  },
  subscribe: function (event: string, callback: (data?: any) => void) {
    //@ts-ignore
    if (!this.events[event]) this.events[event] = [];
    //@ts-ignore
    this.events[event].push(callback);
  },
  delete: function (event: string) {
    //@ts-ignore
    delete this.events[event];
  },
};

export const getDeviceType = () => {
  const ua = window.navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    return "mobile";
  }
  return "desktop";
};

/**
 * функция для выбора нужного сколнения слова на основе переданного значения
 * @param n - значение, относительно которого нужно склонять слово
 * @param textForms - склонения слова - 1, 2, 5 - [человек, человека, человек]
 * @returns
 */
export const num2str = (n: number, textForms: string[]) => {
  n = Math.abs(n) % 100;
  var n1 = n % 10;
  if (n > 10 && n < 20) {
    return textForms[2];
  }
  if (n1 > 1 && n1 < 5) {
    return textForms[1];
  }
  if (n1 === 1) {
    return textForms[0];
  }
  return textForms[2];
};

export const copy = <T>(data: T): T => JSON.parse(JSON.stringify(data));

export const getGlobalCurrency = (
  value: number | string | null | undefined,
): string => {
  if (value === null || value === undefined) {
    return "";
  }

  const amount = typeof value === "string" ? Number(value) : value;

  if (!isFinite(amount)) {
    return "";
  }

  const prefixKey = amount < 0 ? "NEGATIVE_PREFIX" : "POSITIVE_PREFIX";
  const suffixKey = amount < 0 ? "NEGATIVE_SUFFIX" : "POSITIVE_SUFFIX";

  const prefix = localStorage.getItem(prefixKey) ?? "";
  const suffix = localStorage.getItem(suffixKey) ?? "";

  return `${prefix}${amount.toLocaleString()}${suffix}`;
};
